import { jsx } from "react/jsx-runtime";
import { Typography } from "./Typography.js";
const Text = ({ as = "p", children, ...props }) => {
  return /* @__PURE__ */ jsx(Typography, { as, type: "body", ...props, children });
};
export {
  Text
};
//# sourceMappingURL=Text.js.map
